var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _vm.showLogin()
        ? _c(
            "v-app",
            {
              class: {
                "simple-slow-opacityAN": _vm.showLoadingScreen,
                "simple-slow-disappear":
                  _vm.loggingIn && !_vm.showLoadingScreen,
              },
              staticStyle: { background: "#fff", opacity: "0" },
              attrs: { id: "dealio" },
            },
            [
              _c(
                "v-slide-x-transition",
                [
                  _c("login", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.showLogin() || _vm.currentPage === "/login") &&
                          _vm.loginTransitionDelay,
                        expression:
                          "\n          (showLogin() || currentPage === '/login') && loginTransitionDelay\n        ",
                      },
                    ],
                    staticStyle: { height: "100%" },
                    attrs: {
                      loadingAccessTokenDone: _vm.loadingAccessTokenDone,
                      sessionExpired: _vm.sessionExpired,
                    },
                    on: {
                      login: (ev) => {
                        _vm.fetchUserSettings()
                        _vm.fetchApplicationInstances()
                        _vm.loginUser(ev, true)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "vue-drawer-layout",
            {
              ref: "drawerLayout",
              staticClass: "accent",
              class: [
                _vm.currentPage.length > 2
                  ? "theme_border"
                  : "supplementary-class",
                _vm.loggingOut ? "simple-slow-disappear" : "",
              ],
              attrs: {
                enable:
                  _vm.$vuetify.breakpoint.mdAndDown && _vm.isMobileOrTablet,
                "drawer-width": 240,
                "drawable-distance": 300,
                animatable: "",
              },
              on: {
                "mask-click": function ($event) {
                  return _vm.$refs.drawerLayout.toggle(false)
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "drawer" }, slot: "drawer" },
                [
                  _c("v-overlay", {
                    attrs: {
                      "z-index": "1",
                      color: "#edeef2",
                      value:
                        _vm.loadingAppUpdate && !_vm.loadingAppUpdateFailed,
                    },
                  }),
                  _c("navigation-bar", {
                    attrs: {
                      muted: _vm.muted,
                      currentPagePath: _vm.currentPage,
                      isMobileOrTablet: _vm.isMobileOrTablet,
                    },
                    on: {
                      "toggle-drawer": function ($event) {
                        return _vm.$refs.drawerLayout.toggle(false)
                      },
                      mute: _vm.mute,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  class: _vm.mainContentClass,
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _c("v-overlay", {
                    attrs: {
                      "z-index": "1",
                      color: "#edeef2",
                      value:
                        _vm.loadingAppUpdate && !_vm.loadingAppUpdateFailed,
                    },
                  }),
                  _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          _vm.soundsDisabled ? (_vm.soundsDisabled = false) : ""
                        },
                      },
                    },
                    [
                      _c(
                        "v-app",
                        {
                          staticClass: "simple-slow-opacityAN",
                          attrs: { id: "dealio" },
                        },
                        [
                          _c("img", {
                            staticClass: "hiddenimage-fetch-for-offline",
                            attrs: {
                              src: "/img/dynamic-src-images/errors/oops-error.svg",
                              alt: "Error",
                            },
                          }),
                          _c("img", {
                            staticClass: "hiddenimage-fetch-for-offline",
                            attrs: {
                              src: "/img/dynamic-src-images/price-guard.svg",
                              alt: "Price Guard",
                            },
                          }),
                          _c("img", {
                            staticClass: "hiddenimage-fetch-for-offline",
                            attrs: {
                              src: "/img/dynamic-src-images/trade-watcher.svg",
                              alt: "Trade Watcher",
                            },
                          }),
                          _vm.$vuetify.breakpoint.lgAndUp
                            ? _c("navigation-bar", {
                                attrs: { currentPagePath: _vm.currentPage },
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "text-center" }),
                          _c(
                            "v-app-bar",
                            {
                              staticClass: "app-bar",
                              attrs: {
                                height: _vm.$vuetify.breakpoint.smAndDown
                                  ? "56"
                                  : "60",
                                "clipped-left": _vm.$vuetify.breakpoint.lgAndUp,
                                flat: "",
                                app: "",
                                dark: "",
                                fixed: "",
                                dense: false,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "toolbar-left justify-start" },
                                [
                                  _c(
                                    "v-toolbar-title",
                                    [
                                      _c(
                                        "v-row",
                                        { staticClass: "my-0" },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              staticClass: "clickable",
                                              style:
                                                _vm.$vuetify.breakpoint.width >
                                                957
                                                  ? "margin-left: 12px;"
                                                  : "margin-left: 12px;",
                                              attrs: {
                                                size: _vm.$vuetify.breakpoint
                                                  .smAndDown
                                                  ? "56px"
                                                  : "60px",
                                                tile: "",
                                              },
                                              on: { click: _vm.toggleDrawer },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "clickableAndZoom_menuIcon",
                                                  staticStyle: {
                                                    "font-size":
                                                      "24px !important",
                                                  },
                                                },
                                                [_vm._v("fa-solid fa-bars ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "toolbar-center justify-center",
                                },
                                [
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade", mode: "out-in" } },
                                    [
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c(
                                            "div",
                                            { key: "topBarLogoKey" },
                                            [
                                              _c("v-img", {
                                                staticClass: "mb-1",
                                                attrs: {
                                                  "max-width": "125",
                                                  src: "/img/dynamic-src-images/logos/SVG-logo-dark-all-white.svg",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "toolbar-right justify-end" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: _vm.$vuetify.theme.dark
                                          ? "primary"
                                          : "white",
                                        text: "",
                                        icon: "",
                                        "aria-label": "user",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.userPanel = !_vm.userPanel
                                        },
                                      },
                                      model: {
                                        value: _vm.userPanel,
                                        callback: function ($$v) {
                                          _vm.userPanel = $$v
                                        },
                                        expression: "userPanel",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: {
                                            "font-size": "1.3rem",
                                          },
                                        },
                                        [_vm._v("fas fa-user")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        "close-on-content-click": "",
                                        "content-class": "user-panel",
                                        auto: "",
                                        "position-x": _vm.userPanelPosition.x,
                                        "position-y": _vm.userPanelPosition.y,
                                      },
                                      model: {
                                        value: _vm.userPanel,
                                        callback: function ($$v) {
                                          _vm.userPanel = $$v
                                        },
                                        expression: "userPanel",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "accent user-panel-content",
                                          staticStyle: { "min-width": "160px" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mx-0 pt-3",
                                              attrs: { justify: "center" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    "x-large": "",
                                                  },
                                                  on: {
                                                    click: _vm.goToUserSettings,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "21px",
                                                          },
                                                          attrs: { dark: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.isAdmin
                                                                  ? "fas fa-users-cog"
                                                                  : "fas fa-user-circle"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "py-2",
                                              attrs: { justify: "center" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.getUserInfo.name) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass:
                                                    "text-center py-0",
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " (" +
                                                      _vm._s(
                                                        _vm.isAdmin
                                                          ? "Admin"
                                                          : "User"
                                                      ) +
                                                      ") "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    text: "",
                                                  },
                                                  on: { click: _vm.logout },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        small: "",
                                                        color: "primary",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "fas fa-sign-out-alt "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" Log Out "),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: _vm.$vuetify.theme.dark
                                          ? "primary"
                                          : "white",
                                        text: "",
                                        icon: "",
                                        "aria-label": "volume",
                                      },
                                      on: { click: _vm.mute },
                                    },
                                    [
                                      !this.muted
                                        ? [
                                            this.volume >= 50
                                              ? _c("v-icon", [
                                                  _vm._v("volume_up"),
                                                ])
                                              : this.volume > 10
                                              ? _c("v-icon", [
                                                  _vm._v("volume_down"),
                                                ])
                                              : _c("v-icon", [
                                                  _vm._v("volume_mute"),
                                                ]),
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "v-icon",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: this.muted,
                                              expression: "this.muted",
                                            },
                                          ],
                                        },
                                        [_vm._v("volume_off")]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "v-badge",
                                    {
                                      staticClass: "notifications-badge",
                                      staticStyle: { "font-size": "12px" },
                                      attrs: {
                                        content:
                                          _vm.TWAlertsTotalLength < 100
                                            ? _vm.TWAlertsTotalLength
                                            : "99+",
                                        value: _vm.TWAlerts.length > 0,
                                        "offset-y": "20",
                                        "offset-x": "20",
                                        color: _vm.$vuetify.theme.dark
                                          ? "primary"
                                          : "white",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            disabled: _vm.TWAlerts.length < 1,
                                            icon: "",
                                            "aria-label": "notifications",
                                            color: _vm.$vuetify.theme.dark
                                              ? "primary"
                                              : "white",
                                          },
                                          on: {
                                            click: _vm.showNotificationsPanel,
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "20px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "icon-new-notification-24x24 "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        transition: "scroll-x-transition",
                                        "close-on-content-click": false,
                                        "content-class": _vm.$vuetify.breakpoint
                                          .xsOnly
                                          ? "notifications-panel-xs notifications-panel-scroll"
                                          : "notifications-panel notifications-panel-scroll",
                                        "position-x": _vm.userPanelPosition.x,
                                        "position-y": _vm.userPanelPosition.y,
                                      },
                                      model: {
                                        value: _vm.notificationsPanel,
                                        callback: function ($$v) {
                                          _vm.notificationsPanel = $$v
                                        },
                                        expression: "notificationsPanel",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "accent" }, [
                                        _c(
                                          "div",
                                          {
                                            key: _vm.notifPanelRenderKey,
                                            staticStyle: {
                                              "max-height": "300px",
                                              "max-width": "234px",
                                              "overflow-y": "auto",
                                              "overflow-x": "hidden",
                                            },
                                            attrs: { id: "notif_history" },
                                            on: {
                                              scroll: function ($event) {
                                                _vm.isAtBottom =
                                                  _vm.checkIfHistoryBottomed()
                                              },
                                            },
                                          },
                                          [
                                            _vm._l(
                                              _vm.TWAlerts,
                                              function (alert, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: alert.id,
                                                    staticClass:
                                                      "alert-wrapper",
                                                    class: {
                                                      "clearAlert-wrapper":
                                                        alert.clear,
                                                      "alert-wrapper":
                                                        _vm.alertsToClearLength <
                                                        30,
                                                      "alert-wrapper-fast":
                                                        _vm.alertsToClearLength >=
                                                        30,
                                                    },
                                                    staticStyle: {
                                                      width: "600px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-lazy",
                                                      {
                                                        attrs: {
                                                          options: {
                                                            threshold: 0.1,
                                                          },
                                                          "min-height": "69",
                                                          transition:
                                                            "fade-transition",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "notification-history-section mt-1 pr-2",
                                                                class: {
                                                                  clearAlert:
                                                                    alert.clear,
                                                                  "notification-panel-alert":
                                                                    _vm.alertsToClearLength <
                                                                    30,
                                                                  "notification-panel-alert-fast":
                                                                    _vm.alertsToClearLength >=
                                                                    30,
                                                                },
                                                                staticStyle: {
                                                                  "border-radius":
                                                                    "12px",
                                                                  "font-size":
                                                                    "12.5px",
                                                                  width:
                                                                    "216px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-row",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pl-2",
                                                                    staticStyle:
                                                                      {
                                                                        "padding-top":
                                                                          "2px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "mb-0 ml-1",
                                                                        staticStyle:
                                                                          {
                                                                            "letter-spacing":
                                                                              "0.6px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Trade Watcher "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-spacer"
                                                                    ),
                                                                    _c(
                                                                      "v-tooltip",
                                                                      {
                                                                        attrs: {
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                  attrs,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                height: 16,
                                                                                                "x-small":
                                                                                                  "",
                                                                                                icon: "",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.acknowledge(
                                                                                                    alert.id
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          "v-btn",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "far fa-check-circle",
                                                                                            staticStyle:
                                                                                              {
                                                                                                height:
                                                                                                  "12px",
                                                                                                "font-size":
                                                                                                  "13px",
                                                                                                "margin-right":
                                                                                                  "2px",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Confirm"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-tooltip",
                                                                      {
                                                                        attrs: {
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                  attrs,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                height: 16,
                                                                                                "x-small":
                                                                                                  "",
                                                                                                icon: "",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.focusOnAlert(
                                                                                                    alert.id,
                                                                                                    index
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          "v-btn",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "fas fa-share",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "font-size":
                                                                                                  "12px",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "See more"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-row",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0",
                                                                    staticStyle:
                                                                      {
                                                                        height:
                                                                          "43px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "pl-1 mb-2",
                                                                        staticStyle:
                                                                          {
                                                                            float:
                                                                              "left",
                                                                            "font-size":
                                                                              "14px",
                                                                            margin:
                                                                              "8px",
                                                                            "margin-left":
                                                                              "9px",
                                                                            "margin-top":
                                                                              "9px",
                                                                          },
                                                                        attrs: {
                                                                          color:
                                                                            "red",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "fas fa-exclamation-triangle "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "mb-1 mt-1 notification-panel",
                                                                        staticStyle:
                                                                          {
                                                                            "max-width":
                                                                              "160px",
                                                                            float:
                                                                              "left",
                                                                            margin:
                                                                              "4px",
                                                                            "margin-right":
                                                                              "0",
                                                                            "font-size":
                                                                              "11px",
                                                                            "letter-spacing":
                                                                              "0.4px",
                                                                            "line-height":
                                                                              "1.2",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              alert.message
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-row",
                                                              {
                                                                class: {
                                                                  clearAlert:
                                                                    alert.clear,
                                                                },
                                                                staticStyle: {
                                                                  width:
                                                                    "234px",
                                                                  "font-size":
                                                                    "10.5px",
                                                                },
                                                                attrs: {
                                                                  justify:
                                                                    "end",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0 mr-5",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        alert.createdOn
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            (_vm.isAtBottom &&
                                              _vm.allAlertsLoaded) ||
                                            (!_vm.loadingHistory &&
                                              _vm.TWAlerts.length < 4) ||
                                            (_vm.isAtBottom &&
                                              !_vm.loadingHistory)
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "text-center mb-0 mt-2",
                                                    class: {
                                                      "hide-slow":
                                                        _vm.clearingAllAlerts,
                                                    },
                                                    staticStyle: {
                                                      "font-size": "12px",
                                                      width: "100%",
                                                      transition: "0.5s",
                                                    },
                                                    attrs: { text: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.loadMoreHistory(
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Load more... ")]
                                                )
                                              : !_vm.clearingAllAlerts
                                              ? _c(
                                                  "v-row",
                                                  {
                                                    staticClass: "mx-0 my-2",
                                                    attrs: {
                                                      justify: "center",
                                                    },
                                                  },
                                                  [
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        size: 20,
                                                        width: "2",
                                                        color: "primary",
                                                        indeterminate: "",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "accent",
                                                staticStyle: {
                                                  width: "224px",
                                                  position: "fixed",
                                                  bottom: "0",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row mx-0 mb-1",
                                                    staticStyle: {
                                                      height: "17px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-0 ml-2",
                                                        staticStyle: {
                                                          "font-size": "12px",
                                                          "margin-top": "2px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.TWAlerts
                                                                .length
                                                            ) +
                                                            "/" +
                                                            _vm._s(
                                                              _vm.TWAlertsTotalLength
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("v-spacer"),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "px-1",
                                                        staticStyle: {
                                                          "font-size":
                                                            "13px !important",
                                                          "text-transform":
                                                            "none !important",
                                                        },
                                                        attrs: {
                                                          text: "",
                                                          rounded: "",
                                                          "x-small": "",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.changeAlertsSort,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-0",
                                                            staticStyle: {
                                                              "letter-spacing":
                                                                "0",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Sort by time "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "ml-1",
                                                            style:
                                                              _vm.sortIconStyle,
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.sortIcon
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass: "px-1",
                                                        staticStyle: {
                                                          "font-size":
                                                            "13px !important",
                                                          "text-transform":
                                                            "none !important",
                                                        },
                                                        attrs: {
                                                          text: "",
                                                          rounded: "",
                                                          "x-small": "",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.clearNotifications,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-0",
                                                            staticStyle: {
                                                              "letter-spacing":
                                                                "0",
                                                            },
                                                          },
                                                          [_vm._v("Clear")]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        ),
                                        _c("div", {
                                          staticClass: "row mr-0",
                                          staticStyle: { height: "17px" },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _c("v-switch", {
                                    staticClass: "ml-2",
                                    staticStyle: { "padding-top": "25px" },
                                    attrs: {
                                      dark: "",
                                      color: _vm.$vuetify.theme.dark
                                        ? "primary"
                                        : "",
                                      "aria-label": "theme switcher",
                                    },
                                    model: {
                                      value: _vm.themeSwitch,
                                      callback: function ($$v) {
                                        _vm.themeSwitch = $$v
                                      },
                                      expression: "themeSwitch",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "v-main",
                            {
                              directives: [
                                {
                                  name: "resize",
                                  rawName: "v-resize",
                                  value: _vm.onResize,
                                  expression: "onResize",
                                },
                              ],
                              staticClass: "accent",
                              staticStyle: { "overflow-x": "hidden" },
                              style: _vm.getContentPadding,
                              attrs: { id: "main-wrapper" },
                            },
                            [
                              _c(
                                "v-container",
                                {
                                  staticClass: "pa-0 ma-0",
                                  staticStyle: { height: "100% !important" },
                                  attrs: { fluid: "" },
                                },
                                [
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _c("router-view", {
                                        ref: "routerView",
                                        attrs: {
                                          windowSizeY: _vm.windowSizeY,
                                          windowSizeX: _vm.windowSizeX,
                                          settingsProfileExists:
                                            _vm.settingsProfileExists,
                                          isNotDesktop: _vm.isMobileOrTablet,
                                          previousPage: _vm.previousPage,
                                          pageReloaded: _vm.pageReloaded,
                                          showUserSettings:
                                            _vm.showUserSettings,
                                          currentEpochTime:
                                            _vm.currentEpochTime,
                                          removeExpiredDataAfter:
                                            _vm.removeExpiredDataAfter,
                                          selectedProfile: _vm.selectedProfile,
                                          settingsLoaded: _vm.settingsLoaded,
                                          connectionLost: _vm.connectionLost,
                                          tradeWatcherMute:
                                            _vm.tradeWatcherMute,
                                          priceGuardMute: _vm.priceGuardMute,
                                          priceguarDataExpiring:
                                            _vm.removeExpiredData,
                                        },
                                        on: {
                                          "ignored-pg-prices-change":
                                            _vm.ignoredPGPricesChange,
                                          "mutate-settings-profile-exists":
                                            function ($event) {
                                              _vm.settingsProfileExists = $event
                                            },
                                          "mutate-selected-profile": function (
                                            $event
                                          ) {
                                            _vm.selectedProfile = $event
                                          },
                                          "set-new-settings":
                                            _vm.setNewSettings,
                                          "analytics-empty":
                                            _vm.changeAnalyticsColor,
                                          "update-alerts-total":
                                            _vm.updateAlertsTotal,
                                          "analytics-tab-change":
                                            _vm.analyticsTabChange,
                                          "update-app-state":
                                            _vm.updateAppStateRemotelyAndLocally,
                                          "mute-trade-watcher":
                                            _vm.muteTradeWatcher,
                                          "mute-priceguard": _vm.mutePriceGuard,
                                          "play-sound": _vm.playSound,
                                          "set-priceguard-expiring":
                                            _vm.assignDataExpiring,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.notificationSupported &&
                          !_vm.notificationsForbidden &&
                          _vm.soundsDisabled &&
                          !_vm.connectionLost
                            ? _c(
                                "v-snackbar",
                                {
                                  class: [
                                    _vm.$vuetify.breakpoint.xsOnly
                                      ? "mobile_alerts snackbar-xs-margin"
                                      : "black--text",
                                    _vm.snackbarPadding,
                                  ],
                                  attrs: {
                                    id: "secondary-snackbar",
                                    color: "primary",
                                    timeout: -1,
                                    "multi-line": "",
                                    left: "",
                                    width: "344",
                                    "content-class": "v-snack-msg",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.soundsDisabled = false
                                    },
                                  },
                                  model: {
                                    value: _vm.soundsDisabled,
                                    callback: function ($$v) {
                                      _vm.soundsDisabled = $$v
                                    },
                                    expression: "soundsDisabled",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0 text-center",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mt-2 ml-1",
                                              attrs: { color: "black" },
                                            },
                                            [
                                              _vm._v(
                                                "fas fa-exclamation-triangle "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: { cols: "10" },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "black--text mb-0" },
                                            [
                                              _vm._v(
                                                " Sounds are disabled. Please click this alert "
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                "or anywhere on the screen to enable them. "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm.notificationsForbidden && !_vm.connectionLost
                            ? _c(
                                "v-snackbar",
                                {
                                  staticClass: "v-snack-no-notif-msg-outer",
                                  attrs: {
                                    id: "secondary-snackbar",
                                    timeout: -1,
                                    "multi-line": "",
                                    left: "",
                                    "content-class":
                                      "v-snack-no-notif-msg-expand",
                                    color: "white",
                                  },
                                  model: {
                                    value: _vm.notificationsForbidden,
                                    callback: function ($$v) {
                                      _vm.notificationsForbidden = $$v
                                    },
                                    expression: "notificationsForbidden",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "mx-0" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0 text-center",
                                          attrs: {
                                            cols: "2",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-1",
                                              attrs: { color: "black" },
                                            },
                                            [_vm._v("fas fa-bell-slash")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: {
                                            cols: "7",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "black--text mb-0" },
                                            [
                                              _vm._v(
                                                " Notifications are blocked. You"
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                "won't be notified of any events. "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-0",
                                          attrs: { cols: "3" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                light: "",
                                                text: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showNotifTutorial =
                                                    !_vm.showNotifTutorial
                                                },
                                              },
                                            },
                                            [_vm._v("enable ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-hover", {
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function ({ hover }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "absolute-force",
                                                class: hover
                                                  ? "grey--text text--darken-2"
                                                  : "black--text",
                                                staticStyle: {
                                                  top: "4px",
                                                  right: "4px",
                                                  "font-size": "14px",
                                                },
                                                attrs: { small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.soundsDisabled = false
                                                    _vm.notificationsForbidden = false
                                                  },
                                                },
                                              },
                                              [_vm._v(" far fa-times-circle ")]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              )
                            : !_vm.notificationSupported && !_vm.connectionLost
                            ? _c(
                                "v-snackbar",
                                {
                                  staticClass: "v-snack-no-notif-msg-outer",
                                  attrs: {
                                    id: "iphone-snackbar",
                                    timeout: -1,
                                    "multi-line": "",
                                    left: "",
                                    "content-class":
                                      "v-snack-no-notif-msg-expand",
                                    color: "primary",
                                  },
                                  model: {
                                    value: _vm.soundsDisabled,
                                    callback: function ($$v) {
                                      _vm.soundsDisabled = $$v
                                    },
                                    expression: "soundsDisabled",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0",
                                      staticStyle: {
                                        height: "65px !important",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0 text-center",
                                          attrs: {
                                            cols: "2",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-1",
                                              attrs: { color: "black" },
                                            },
                                            [_vm._v("fas fa-bell-slash")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: {
                                            cols: "9",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "black--text mb-0" },
                                            [
                                              _vm._v(
                                                " Your device doesn't support notifications. You won't be notified if you exit the app. "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-snackbar",
                            {
                              staticClass: "v-snack-app-update-outer",
                              class: _vm.loadingAppUpdateFailed
                                ? "update-failed"
                                : "currently-updating",
                              attrs: {
                                id: "iphone-snackbar",
                                timeout: -1,
                                "multi-line": "",
                                left: "",
                                "content-class":
                                  "v-snack-app-update new-version-snack",
                                color: "info",
                              },
                              model: {
                                value: _vm.appUpdateAvailable,
                                callback: function ($$v) {
                                  _vm.appUpdateAvailable = $$v
                                },
                                expression: "appUpdateAvailable",
                              },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mx-0 pl-5 pr-1",
                                  staticStyle: { height: "65px !important" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0",
                                      attrs: {
                                        cols: _vm.loadingAppUpdateFailed
                                          ? 11
                                          : 8,
                                        "align-self": "center",
                                      },
                                    },
                                    [
                                      !_vm.loadingAppUpdateFailed
                                        ? _c(
                                            "p",
                                            { staticClass: "white--text mb-0" },
                                            [
                                              _vm._v(
                                                " A new version of Dealio is available! "
                                              ),
                                            ]
                                          )
                                        : _c("div", [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "white--text mb-0",
                                              },
                                              [_vm._v("Oops! Couldn't update.")]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass: "white--text mb-0",
                                              },
                                              [
                                                _vm._v(
                                                  " You can update manually with Ctrl+F5. "
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ]
                                  ),
                                  !_vm.loadingAppUpdateFailed
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0 text-center",
                                          attrs: {
                                            cols: "3",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          !_vm.loadingAppUpdate
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass: "px-2",
                                                  staticStyle: {
                                                    "margin-bottom": "2px",
                                                    "margin-left": "-2px",
                                                  },
                                                  attrs: {
                                                    color: "#b5d0ff",
                                                    text: "",
                                                  },
                                                  on: { click: _vm.updateApp },
                                                },
                                                [_vm._v("UPDATE ")]
                                              )
                                            : _c("v-progress-circular", {
                                                attrs: {
                                                  size: 20,
                                                  width: "2",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              }),
                                          _c("v-spacer"),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0",
                                      attrs: { cols: "1" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            "margin-top": "5px",
                                            "margin-left": "-10px",
                                          },
                                          attrs: {
                                            icon: "",
                                            color: "grey lighten-3",
                                          },
                                          on: { click: _vm.dismissAppUpdate },
                                        },
                                        [_c("v-icon", [_vm._v("close")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-snackbar",
                            {
                              staticClass: "small-snack",
                              class: [
                                _vm.$vuetify.breakpoint.xsOnly
                                  ? "mobile_alerts snackbar-xs-margin"
                                  : "black--text",
                                _vm.snackbarPadding,
                              ],
                              attrs: {
                                color: "info",
                                timeout: -1,
                                "multi-line": "",
                                left: "",
                                width: "320",
                                "content-class": "v-snack-msg",
                              },
                              model: {
                                value: _vm.connectionLost,
                                callback: function ($$v) {
                                  _vm.connectionLost = $$v
                                },
                                expression: "connectionLost",
                              },
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-right pa-0",
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        height: "32px",
                                      },
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-7",
                                          staticStyle: {
                                            "margin-bottom": "2px !important",
                                          },
                                          attrs: {
                                            id: "no-connection-icon",
                                            small: "",
                                          },
                                        },
                                        [_vm._v("fas fa-wifi ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0",
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                        "align-items": "center",
                                        height: "32px",
                                      },
                                      attrs: { cols: "10" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "white--text mb-0 mr-2",
                                          staticStyle: {
                                            "font-size": "16px",
                                            "margin-left": "-4px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " No server connection available "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("notifier", {
                            attrs: {
                              soundsDisabled: _vm.soundsDisabled,
                              mobileNotStandalone: _vm.mobileNotStandalone,
                              isMobileOrTablet: _vm.isMobileOrTablet,
                              connectionLost: _vm.connectionLost,
                              appUpdateAvailable: _vm.appUpdateAvailable,
                            },
                          }),
                          _c("div", { attrs: { id: "audio" } }, [
                            _c("audio", {
                              ref: "audiofile",
                              staticStyle: { display: "none" },
                              attrs: {
                                id: "my-audio",
                                loop: _vm.innerLoop,
                                muted: true,
                                preload: "auto",
                              },
                            }),
                          ]),
                          _c(
                            "v-dialog",
                            {
                              attrs: {
                                transition: "scroll-x-transition",
                                "overlay-color": "grey darken-2",
                                width: "850px",
                                persistent: "",
                              },
                              model: {
                                value: _vm.showNotifTutorial,
                                callback: function ($$v) {
                                  _vm.showNotifTutorial = $$v
                                },
                                expression: "showNotifTutorial",
                              },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "accent pa-4 pr-0",
                                  class: {
                                    "pl-0": _vm.$vuetify.breakpoint.xsOnly,
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "absolute",
                                      staticStyle: {
                                        top: "12px",
                                        right: "12px",
                                      },
                                      attrs: { icon: "", small: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showNotifTutorial =
                                            !_vm.showNotifTutorial
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-times",
                                        staticStyle: {
                                          "font-size": "0.875rem",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "pa-0 mb-1 ml-2",
                                      class: {
                                        "ml-4": _vm.$vuetify.breakpoint.xsOnly,
                                      },
                                      staticStyle: { "margin-top": "-6px" },
                                    },
                                    [_vm._v("Enabling device notifications ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "520px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [
                                      !_vm.isMobileOrTablet
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("1")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [_vm._v("Open Site Info")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "24px",
                                                  "border-left":
                                                    "1px solid rgba(255, 255, 255, 0.12)",
                                                  "margin-left": "36px",
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    width: "480px",
                                                    src: require("./assets/other-images/site-info.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("2")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Allow Notifications"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "24px",
                                                  "border-left":
                                                    "1px solid rgba(255, 255, 255, 0.12)",
                                                  "margin-left": "36px",
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    width: "480px",
                                                    src: require("./assets/other-images/allow-notifications.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("3")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Reload the page and that's it! "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("1")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [_vm._v("Open Site Info")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "24px",
                                                  "border-left":
                                                    "1px solid rgba(255, 255, 255, 0.12)",
                                                  "margin-left": "36px",
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    width: "480px",
                                                    src: require("./assets/other-images/mobile/step-1.jpg"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("2")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [_vm._v("Open Site Settings")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "24px",
                                                  "border-left":
                                                    "1px solid rgba(255, 255, 255, 0.12)",
                                                  "margin-left": "36px",
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    width: "480px",
                                                    src: require("./assets/other-images/mobile/step-2.jpg"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("3")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Open Notifications Settings "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "24px",
                                                  "border-left":
                                                    "1px solid rgba(255, 255, 255, 0.12)",
                                                  "margin-left": "36px",
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    width: "480px",
                                                    src: require("./assets/other-images/mobile/step-3.jpg"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("4")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Enable Notifications"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "24px",
                                                  "border-left":
                                                    "1px solid rgba(255, 255, 255, 0.12)",
                                                  "margin-left": "36px",
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    width: "480px",
                                                    src: require("./assets/other-images/mobile/step-4.jpg"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-stepper__step v-stepper__step--active",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-stepper__step__step primary",
                                                  },
                                                  [_vm._v("5")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-stepper__label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Reload the page and that's it! "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("profile-selection-dialog", {
                            attrs: {
                              profiles: _vm.configurationProfiles,
                              deviceType: _vm.deviceType,
                              noProfilesExist: _vm.noProfilesExist,
                              isMobileOrTablet: _vm.isMobileOrTablet,
                              isAdmin: _vm.isAdmin,
                              getUserInfo: _vm.getUserInfo,
                            },
                            on: {
                              "delete-unsaved-profile":
                                _vm.deleteUnsavedProfile,
                              "refresh-user-profiles": _vm.refreshUserProfiles,
                              "new-profile-created": _vm.newProfileCreated,
                              "profile-selected": _vm.applySelectedProfile,
                            },
                            model: {
                              value: _vm.profileSelectionDialog,
                              callback: function ($$v) {
                                _vm.profileSelectionDialog = $$v
                              },
                              expression: "profileSelectionDialog",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }